export const getTargetInput = (ev: Event) => ev.currentTarget as HTMLInputElement

const rootEventFactory = (component: string) => (ev: string, targetId: string) =>
  `hp::${component}::${ev}:${targetId}`

export const makeRootDialogEvent = rootEventFactory('modal')
export const makeRootToolTipEvent = rootEventFactory('toolTip')

export const makeRootChatEvent = rootEventFactory('chat')

export const RUDDERSTACK_READY = rootEventFactory('analytics')('ready', 'rudderstack')
